import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit, signal, WritableSignal } from '@angular/core';
import { LnPagesArmorComponent } from '@components/ln-pages-armor/ln-pages-armor.component';
import { LnHeroComponent } from '@components/ln-hero/ln-hero.component';
import { ArtisansDesignersCreatedProductsComponent } from '@components/artisans-designers-created-products/artisans-designers-created-products.component';
import { SpecialProductsSearchResultComponent } from '@components/special-products-search-result/special-products-search-result.component';
import { ArtisanDesignerSearchResultComponent } from '@components/artisan-designer-search-result/artisan-designer-search-result.component';
import { ActivatedRoute } from '@angular/router';
import { SearchBarValue } from '@core/services/search-bar-value/search-bar-value';
import { ProductServiceParamsInterface } from '@interfaces/products/product_service_params_interface';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SearcherService } from '@core/services/searcher/searcher.service';
import { SpecialProductInterface } from '@interfaces/products/special_product_interface';
import { SellerInterface } from '@interfaces/artisan/seller_interface';
import { ApiResponse } from '@interfaces/api/api.interface';
import { SearchArtisantAndProductsDataInterface } from '@interfaces/searcher/search_artisant_and_products_data_interface';
import { ScrollService } from '@core/services/scroll/scroll.service';

@Component({
  selector: 'ln-search-result',
  imports: [
    LnPagesArmorComponent,
    LnHeroComponent,
    ArtisansDesignersCreatedProductsComponent,
    SpecialProductsSearchResultComponent,
    ArtisanDesignerSearchResultComponent,
  ],
  templateUrl: './search-result.component.html',
  styleUrl: './search-result.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchResultComponent implements OnInit {
  private TAG = 'SearchResultComponent';
  private routes = inject(ActivatedRoute);
  private query: WritableSignal<string> = signal('');
  searchBarValue = inject(SearchBarValue);
  private searcher = inject(SearcherService);
  private destroyRef = inject(DestroyRef);
  products: WritableSignal<SpecialProductInterface[] | null> = signal<SpecialProductInterface[] | null>(null);
  sellers: WritableSignal<SellerInterface[] | null> = signal<SellerInterface[] | null>(null);
  private scrollService = inject(ScrollService);

  ngOnInit(): void {
    this.getQuery();
  }

  getQuery(): void {
    this.routes.queryParams.subscribe(params => {
      const query = params['query'];
      if (query) {
        this.query.set(query);
        this.searchBarValue.setSearchBarValue(query);
        this.searchProductsAndArtisans();
      }
    });
  }

  searchProductsAndArtisans() {
    const querryParams: ProductServiceParamsInterface = { q: this.query() };

    this.searcher
      .searchProductsAndArtisans(querryParams)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res: ApiResponse<SearchArtisantAndProductsDataInterface>) => {
          const products = res?.data?.productsData?.productos ?? [];
          this.products.set(products);
          const sellers = res?.data?.sellersData?.sellers ?? [];
          this.sellers.set(sellers);
          this.scrollToBodyStart();
        },
        error: err => {
          console.log(`${this.TAG} ${err}`);
          this.products.set([]);
          this.sellers.set([]);
        },
      });
  }

  private scrollToBodyStart() {
    this.scrollService.scrollToElementById('bodyStart', 'start');
  }
}
